export default function PrivacyPolicy() {
  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        lineHeight: 1.7,
        backgroundColor: "#f9f9f9",
        color: "#333",
        padding: "40px 20px",
        maxWidth: 900,
        margin: "auto",
      }}
    >
      <h1 style={{ color: "#2c3e50" }}>Privacy Statement</h1>
      <p>
        <strong>Effective Date:</strong> 15-04-2025
      </p>

      <p>
        <strong>Delivery Driver App</strong> is provided by{" "}
        <strong>Get Stuffed Ltd</strong> and is intended for use solely by
        company employees to record deliveries to designated shops. This App is
        part of our internal delivery management system and does not require
        public registration or account creation.
      </p>

      <h2 style={{ color: "#2c3e50" }}>1. Purpose of the App</h2>
      <p>
        The App is used exclusively by delivery drivers employed by Get Stuffed
        Ltd to log and confirm deliveries. It functions as a business tool and
        is not available to the general public.
      </p>

      <h2 style={{ color: "#2c3e50" }}>2. User Access</h2>
      <p>
        Drivers do not sign up through the App. User accounts are created and
        managed by administrators via a secure internal portal. Only authorized
        employees have access to the App.
      </p>

      <h2 style={{ color: "#2c3e50" }}>3. Information Collected</h2>
      <ul style={{ paddingLeft: 20 }}>
        <li>
          <strong>Delivery Records:</strong> Information related to each
          delivery, such as shop details, delivery time and date, delivery
          notes.
        </li>
        <li>
          <strong>User Identification:</strong> Employee name or ID, assigned
          during account setup by the administrator.
        </li>
        <li>
          <strong>Device and App Usage Data:</strong> Basic diagnostic
          information such as app version and error logs to support maintenance
          and troubleshooting.
        </li>
      </ul>
      <p>
        <strong>Note:</strong> The App does not collect or store any location
        (GPS) data.
      </p>

      <h2 style={{ color: "#2c3e50" }}>4. Data Storage and Security</h2>
      <p>
        All data recorded through the App is securely transmitted to and stored
        on Get Stuffed internal servers or authorized cloud storage providers.
        We use appropriate technical and organizational measures to protect all
        data from unauthorized access or loss.
      </p>

      <h2 style={{ color: "#2c3e50" }}>5. Data Sharing</h2>
      <p>
        Data collected through the App is used strictly for internal operations
        and is not sold or shared with any third parties, except where legally
        required or necessary for internal auditing and compliance.
      </p>

      <h2 style={{ color: "#2c3e50" }}>6. User Rights</h2>
      <p>
        Employees may request access to their delivery records or other data
        collected via the App by contacting the company’s system administrator
        or data protection contact.
      </p>

      <h2 style={{ color: "#2c3e50" }}>7. Changes to This Privacy Statement</h2>
      <p>
        We may update this privacy statement to reflect changes in the App or
        legal requirements. Users will be notified through internal
        communication channels.
      </p>

      <h2 style={{ color: "#2c3e50" }}>8. Contact Information</h2>
      <p>
        For any questions or concerns regarding this Privacy Statement or the
        App’s data practices, please contact:
      </p>
      <p>
        <strong>Get Stuffed</strong>
        <br />
        Email:{" "}
        <a href="mailto:get_stuffed@yahoo.com" style={{ color: "#007bff" }}>
          get_stuffed@yahoo.com
        </a>
        <br />
        Phone: 07477643029
        <br />
        Address: Unit 6, Legrams Terrace, Bradford, BD7 1LN
      </p>
    </div>
  );
}
